// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2NR-s","rootCenter":"LoadMoreObserver_rootCenter__N2kyJ","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2eY2x"};